'use strict';
import jwtDecode from 'jwt-decode';
import get from 'lodash/get';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/catch';
import {Observable} from 'rxjs/Observable';
import {FIREBASE_TOKEN} from '../../config/constants/auth-keys';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {authFirebase, firebaseAuthError, firebaseAuthSuccess, initAuthComplete} from '../actions';
import {logger} from './logger';

export const epics = [
  onAuthFirebase,
];

onAuthFirebase.$inject = [
  'FirebaseUtil',
  'AuthService',
  'authCacheService',
];

export function onAuthFirebase(action$, store, dependencies) {
  return action$.ofType(authFirebase.TYPE).map((action) => action.payload.token)
    .switchMap(firebaseToken => {
      try {
        const firebaseData = jwtDecode(firebaseToken); // throws if token is invalid
        const userId = get(firebaseData, 'd.uid', null);
        dependencies.authCacheService.setItem(FIREBASE_TOKEN, firebaseToken);
        return Observable.fromPromise(
          dependencies.FirebaseUtil
            .firebaseRef()
            .authWithCustomToken(firebaseToken)
            .then((authData) => {
              // Legacy hook
              dependencies.AuthService.onFirebaseAuth(authData);
              return firebaseAuthSuccess(userId);
            })
            .catch((err) => firebaseAuthError(err))
        );
      } catch (e) {
        return Observable.of(firebaseAuthError(e));
      }
    })
    .mergeMap((action) =>
      // side effect: trigger auth-init-complete now.
      Observable.from([
        action,
        action.payload.err
          ? initAuthComplete(action.payload.err, null, 'onAuthFirebase')
          : initAuthComplete(null, action.payload.userId, 'onAuthFirebase'),
      ])
    )
    .catch(epicErrorHandler(logger, 'onAuthFirebase'));
}



// WEBPACK FOOTER //
// ./src/js/auth/epics/authFirebase.js